import React from "react";
import { useAccess } from "../utils/useAccess"; //adjust path
import NoAccessCard from "./NoAccessCard";

export default function PageGate({
  perm,
  children,
}: {
  perm: string | string[];
  children: React.ReactNode;
}) {
  const { loading, can } = useAccess();

  //console.log(perm, "this is the said perm");

  if (loading) return null;

  const ok = can.allow(perm, "any");
  if (!ok) {
    const label = Array.isArray(perm)
      ? `You need one of: ${perm.join(", ")}`
      : `You need permission: ${perm}`;
    return <NoAccessCard label={label} />;
  }

  return <>{children}</>;
}
